export const fmvData = [
  // SPECIAL ITEMS
{ name: 'Painting', category: 'Art', low: 0, high: 0, isSpecial: true },

// CLOTHING - WOMEN
{ name: 'Dress', category: 'Women', low: 7, high: 32 },
{ name: 'Shirt', category: 'Women', low: 5, high: 12 },
{ name: 'Pants', category: 'Women', low: 5, high: 28 },
{ name: 'Sweater', category: 'Women', low: 5, high: 16 },
{ name: 'Blouse', category: 'Women', low: 5, high: 11 },
{ name: 'Shorts', category: 'Women', low: 5, high: 22 },
{ name: 'Shoes', category: 'Women', low: 4, high: 36 },
{ name: 'Socks', category: 'Women', low: 0.05, high: 1.2 },
{ name: 'Belts', category: 'Women', low: 6, high: 18 },
{ name: 'Underwear', category: 'Women', low: 0.05, high: 1.2 },
{ name: 'Sports Bra', category: 'Women', low: 5, high: 12 },
{ name: '2pc Suit', category: 'Women', low: 12, high: 105 },
{ name: 'Jacket', category: 'Women', low: 12, high: 52 },
{ name: 'Overcoat', category: 'Women', low: 4, high: 11 },
{ name: 'Handbag', category: 'Women', low: 3, high: 12 },
{ name: 'Hat', category: 'Women', low: 2, high: 11 },
{ name: 'Stylish Shirt', category: 'Women', low: 7, high: 20 },
{ name: 'Branded Shirt', category: 'Women', low: 22, high: 45 },
{ name: 'Branded Pants', category: 'Women', low: 22, high: 40 },
{ name: 'Ties', category: 'Women', low: 6, high: 18 },

// CLOTHING - MEN
{ name: 'Shirt', category: 'Men', low: 5, high: 11 },
{ name: 'Stylish Shirt', category: 'Men', low: 7, high: 20 },
{ name: 'Branded Shirt', category: 'Men', low: 22, high: 45 },
{ name: 'Pants', category: 'Men', low: 5, high: 28 },
{ name: 'Branded Pants', category: 'Men', low: 22, high: 40 },
{ name: 'Shorts', category: 'Men', low: 5, high: 22 },
{ name: 'Socks', category: 'Men', low: 0.05, high: 1.2 },
{ name: 'Belts', category: 'Men', low: 6, high: 18 },
{ name: 'Shoes', category: 'Men', low: 4, high: 36 },
{ name: 'Underwear', category: 'Men', low: 0.05, high: 1.2 },
{ name: 'Ties', category: 'Men', low: 6, high: 18 },
{ name: '2pc Suit', category: 'Men', low: 6, high: 105 },
{ name: 'Jacket', category: 'Men', low: 12, high: 52 },
{ name: 'Overcoat', category: 'Men', low: 4, high: 11 },
{ name: 'Hat', category: 'Men', low: 2, high: 11 },
{ name: 'Handbag', category: 'Men', low: 3, high: 14 },

// CLOTHING - CHILDREN
{ name: 'Boots', category: 'Children', low: 7, high: 12 },
{ name: 'Dress', category: 'Children', low: 3, high: 12 },
{ name: 'Pants / Jeans', category: 'Children', low: 3, high: 12 },
{ name: 'Shirt', category: 'Children', low: 3, high: 12 },
{ name: 'Shoes', category: 'Children', low: 4, high: 12 },
{ name: 'Snowsuit', category: 'Children', low: 3, high: 12 },
{ name: 'Sweater', category: 'Children', low: 3, high: 12 },
{ name: 'Shorts', category: 'Children', low: 3, high: 12 },
{ name: 'Socks', category: 'Children', low: 0.05, high: 1.2 },
{ name: 'Underwear', category: 'Children', low: 0.05, high: 1.2 },
{ name: 'Belts', category: 'Children', low: 1.2, high: 7 },
{ name: 'Hat', category: 'Children', low: 1.2, high: 6 },
{ name: 'Jacket', category: 'Children', low: 7, high: 30 },
{ name: 'Overcoat', category: 'Children', low: 6, high: 24 },
{ name: '2pc Suit', category: 'Children', low: 12, high: 70 },
{ name: 'Handbag', category: 'Children', low: 1.2, high: 7 },

// ACCESSORIES
{ name: 'Stone Cigars', category: 'Accessories', low: 5, high: 28 },
{ name: 'Pillow Cases', category: 'Accessories', low: 2.2, high: 6 },
{ name: 'Sheet', category: 'Accessories', low: 2.2, high: 10 },
{ name: 'Curtain', category: 'Accessories', low: 2.2, high: 8 },
{ name: 'Internet Router', category: 'Accessories', low: 6, high: 55 },
{ name: 'Wireless Water Meter', category: 'Accessories', low: 22, high: 70 },
{ name: 'Area Rug', category: 'Accessories', low: 2.5, high: 18 },
{ name: 'Blanket', category: 'Accessories', low: 3.5, high: 16 },
{ name: 'Books', category: 'Accessories', low: 0.65, high: 2.2 },
{ name: 'Coffee Maker', category: 'Accessories', low: 6, high: 12 },
{ name: 'Drapes', category: 'Accessories', low: 2.2, high: 6 },
{ name: 'Iron', category: 'Accessories', low: 3.5, high: 12 },
{ name: 'Pillow', category: 'Accessories', low: 2.2, high: 6 },
{ name: 'Radio', category: 'Accessories', low: 1.2, high: 12 },
{ name: 'Vacuum Cleaner', category: 'Accessories', low: 6, high: 70 },

// FURNITURE & HOUSEHOLD
{ name: 'Small Decoration Art', category: 'Furniture', low: 6, high: 18 },
{ name: 'Cookware and Plates', category: 'Furniture', low: 40, high: 150 },
{ name: 'Plates and Bowls', category: 'Furniture', low: 3.5, high: 18 },
{ name: 'Lamp, Floor', category: 'Furniture', low: 9, high: 40 },
{ name: 'Lamp, Table', category: 'Furniture', low: 3.5, high: 22 },
{ name: 'Clock', category: 'Furniture', low: 3.5, high: 12 },
{ name: 'Kitchen Pancake', category: 'Furniture', low: 6, high: 18 },
{ name: 'Cookware Set', category: 'Furniture', low: 40, high: 150 },
{ name: 'Kitchen Tools', category: 'Furniture', low: 1.2, high: 3.5 },
{ name: 'Coffee Table', category: 'Furniture', low: 18, high: 115 },
{ name: 'Dresser', category: 'Furniture', low: 22, high: 90 },
{ name: 'End Table', category: 'Furniture', low: 12, high: 85 },
{ name: 'Kitchen Set', category: 'Furniture', low: 40, high: 150 },
{ name: 'Sofa', category: 'Furniture', low: 45, high: 450 },
{ name: 'Stuffed Chair', category: 'Furniture', low: 12, high: 85 },

// EQUIPMENT
{ name: 'Battery Back-ups', category: 'Equipment', low: 1.8, high: 2.5 },
{ name: 'Desktop Computers', category: 'Equipment', low: 25, high: 60 },
{ name: 'Keyboards', category: 'Equipment', low: 0.35, high: 12 },
{ name: 'Laptops', category: 'Equipment', low: 30, high: 72 },
{ name: 'Mice', category: 'Equipment', low: 0.35, high: 6 },
{ name: 'Printers', category: 'Equipment', low: 1.2, high: 12 },
{ name: 'Car Bumper', category: 'Equipment', low: 22, high: 115 }
];

export const itemNames = [...new Set(fmvData.map(item => item.name))].sort();
export const categories = [...new Set(fmvData.map(item => item.category))].sort();